<popup header="{{'自訂常用功能排序'|i18n:'chm00000621':null}}" [(visible)]="display" modal="modal" width="800" [height]="height"
    [contentHeight]="contentHeight" responsive="true" top="0" (onHide)="onHide()" (onShow)="onShow()">

    <div class="modal_area">
        <div class="txt ct">{{'您可以拖曳清單來自訂排序'|i18n:'chm00001546':null}}</div>
        <dragdroplist #dd [(ngModel)]="favoriteTaskList" styleClass="ui_list my_favlist">

            <ng-template let-item pTemplate="item">

                <div class="btn btn-block">
                    <a href="#" class="btn tb_btn1 float-right" (click)="preventNavigation($event)">
                        <i class="fa fa-trash-o" aria-hidden="true" (click)="removeItem($event,item)"></i>
                    </a>
                    {{item.name}}
                </div>

            </ng-template>
        </dragdroplist>
    </div>
    <p-footer>
        <div class="btn_box">
            <commandButton [mask]="false" (onClick)="saveFavorite()">{{'確定'|i18n:'Confirm':null}}
            </commandButton>
        </div>

    </p-footer>
</popup>